// export const basePathApi = 'https://devapi.grouptravelvideos.com/'
export const basePathApi = process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '/')
    : process.env.REACT_APP_ENV === 'production'
        ? 'https://api.grouptravelvideos.com/'
        : 'https://devapi.grouptravelvideos.com/'
